import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  CardContent,
  Box,
  Typography,
  Button,
  useMediaQuery,
  Grid,
  Pagination,
  Alert,
  AlertTitle,
  Chip,
} from "@mui/material";
import CommonModal from "./HWSubmitModal";
import JailBars from "../assets/jail_bars.png";
import LayoutWithIcons from "./LayoutWithIcons";
import { useCharactersContext } from "../hooks/Context";

interface WordAndImage {
  word: string;
  mediaUrl: string;
}

interface Question {
  updatedBy: string;
  question: string;
  mediaUrl: string;
  difficultyLevel: string;
  answerType: number;
  active: boolean;
  marks: number;
  updatedDate: string;
  subjectId: number;
  questionBankId: number;
  classId: number;
  createdDate: string;
  createdBy: string;
  optionsList: any[];
  questionPaperId: number;
  uiType: number;
  remarks: string;
}

interface Layout13Props {
  Questions: Question[];
  sectionName: string;
}

interface QuestionState {
  questionIndex: number;
  draggedWord: string | null;
  droppedArticle: string | null;
}

const Layout13: React.FC<Layout13Props> = ({ Questions, sectionName }) => {
  const isMobile = useMediaQuery("(max-width: 600px)");
  const isTablet = useMediaQuery("(max-width:820px)");
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const currentQuestion = Questions[currentQuestionIndex];
  //console.log("currentQuestion", currentQuestion);
  const sentences = currentQuestion?.question.split("<br>");
  const questionText1 = sentences[0];
  const questionText2 = sentences[1];
  const questionText3 = sentences[2];
  const words = sentences.slice(3, 9).filter(Boolean);
  const divRef = useRef<HTMLDivElement | null>(null);
  const [showAlert, setShowAlert] = useState(false);
  const handleAlertClose = () => setShowAlert(false);
  setTimeout(handleAlertClose, 3000);

  console.log("sentences", sentences)

  console.log('questionText3')

  const mediaUrls = currentQuestion?.mediaUrl.split(",");
  const wordsAndImages: WordAndImage[] = words.map((word, index) => {
    return {
      word,
      mediaUrl: mediaUrls[index],
    };
  });
  // const loadWordsAndImageFromLocalStorage = (questionBankId: any) => {
  //   const storedWordsAndImage = localStorage.getItem(
  //     `wordsAndImage_${questionBankId}`
  //   );
  //   return storedWordsAndImage
  //     ? JSON.parse(storedWordsAndImage)
  //     : wordsAndImages;
  // };
  const loadWordsAndImageFromLocalStorage = (questionBankId: any) => {
    const storedWordsAndImage = localStorage.getItem(
      `wordsAndImage_${questionBankId}`
    );
    return storedWordsAndImage ? JSON.parse(storedWordsAndImage) : [];
  };

  // const [wordsAndImage, setWordsAndImage] = useState(wordsAndImages);
  const [wordsAndImage, setWordsAndImage] = useState(() =>
    loadWordsAndImageFromLocalStorage(currentQuestion?.questionBankId || "")
  );

  //  console.log("W&I", wordsAndImage);

  const correctOptions = currentQuestion?.optionsList?.map(
    (option: { option: any }) => option.option
  );

  // console.log("COrrect Options", correctOptions);

  // useEffect(() => {
  //   const currentQuestion = Questions[currentQuestionIndex];
  //   const mediaUrls = currentQuestion?.mediaUrl.split(",");
  //   const wordsAndImages: WordAndImage[] = words.map((word, index) => {
  //     return {
  //       word,
  //       mediaUrl: mediaUrls[index],
  //     };
  //   });
  //   setWordsAndImage(wordsAndImages);
  //   setDraggedWord(null);
  //   setDroppedWords([]);
  // }, [currentQuestionIndex, Questions]);
  // useEffect(() => {
  //   const currentQuestion = Questions[currentQuestionIndex];
  //   const mediaUrls = currentQuestion?.mediaUrl.split(",");
  //   const wordsAndImages: WordAndImage[] = words.map((word, index) => {
  //     return {
  //       word,
  //       mediaUrl: mediaUrls[index],
  //     };
  //   });

  //   // Only update the state if it's not already set
  //   if (!wordsAndImage.length) {
  //     setWordsAndImage(wordsAndImages);
  //   }
  //   setDraggedWord(null);
  //   setDroppedWords([]);
  // }, [currentQuestionIndex, Questions]);
  useEffect(() => {
    const currentQuestion = Questions[currentQuestionIndex];
    const mediaUrls = currentQuestion?.mediaUrl.split(",");
    const wordsAndImages: WordAndImage[] = words.map((word, index) => {
      return {
        word,
        mediaUrl: mediaUrls[index],
      };
    });

    // Load wordsAndImage from local storage for the current question
    const loadedWordsAndImage = loadWordsAndImageFromLocalStorage(
      currentQuestion?.questionBankId || ""
    );

    // Use the loaded data if available, or use the newly generated data
    setWordsAndImage(
      loadedWordsAndImage.length ? loadedWordsAndImage : wordsAndImages
    );

    setDraggedWord(null);
    setDroppedWords([]);
  }, [currentQuestionIndex, Questions]);

  const [modalOpen, setModalOpen] = useState(false);
  const [isCorrectSubmission, setIsCorrectSubmission] = useState<
    boolean | null
  >(null);
  const [draggedWord, setDraggedWord] = useState<string | null>(null);
  const questionBankId = currentQuestion?.questionBankId;
  const loadDroppedWordsFromLocalStorage = (questionBankId: any) => {
    const storedDroppedWords = localStorage.getItem(
      `droppedWords_${questionBankId}`
    );
    return storedDroppedWords ? JSON.parse(storedDroppedWords) : [];
  };

  // const [droppedWords, setDroppedWords] = useState<WordAndImage[]>([]);
  const [droppedWords, setDroppedWords] = useState(() =>
    loadDroppedWordsFromLocalStorage(currentQuestion?.questionBankId || "")
  );

  const {
    questionScores,
    setQuestionScores,
    isViewMode,
    examAnswers,
    setExamAnswers,
  } = useCharactersContext();

  const handleFormSubmit = () => {
    setShowAlert(true);
    let droppedWordsText = droppedWords.map((item: { word: any }) => item.word);
    // console.log("dropped words", droppedWordsText);
    // console.log("correct options", correctOptions);

    const isCorrect = correctOptions.every((word) =>
      droppedWordsText.includes(word)
    );

    setIsCorrectSubmission(isCorrect);

    if (isCorrect) {
      setIsCorrectSubmission(true);
      // playCorrectSound();
      setModalOpen(true);
      const questionIndex = questionScores.findIndex(
        (item) => item.questionBankId === currentQuestion.questionBankId
      );

      if (questionIndex !== -1) {
        // Update the existing score
        const updatedScores = [...questionScores];
        updatedScores[questionIndex] = {
          questionBankId: currentQuestion.questionBankId,
          questionPaperId: currentQuestion.questionPaperId,
          score: currentQuestion.marks,
          layoutNumber: currentQuestion.uiType,
          sectionName: sectionName,
        };
        setQuestionScores(updatedScores);
      } else {
        // Add a new score for the question
        setQuestionScores((prevScores) => [
          ...prevScores,
          {
            questionBankId: currentQuestion.questionBankId,
            questionPaperId: currentQuestion.questionPaperId,
            score: currentQuestion.marks,
            layoutNumber: currentQuestion.uiType,
            sectionName: sectionName,
          },
        ]);
      }
    } else {
      setIsCorrectSubmission(false);
      // playInCorrectSound();
      setModalOpen(true);
      setQuestionScores((prevScores) => [
        ...prevScores,
        {
          questionBankId: currentQuestion.questionBankId,
          questionPaperId: currentQuestion.questionPaperId,
          score: 0,
          layoutNumber: currentQuestion.uiType,
          sectionName: sectionName,
        },
      ]);
    }

    // console.log("questionScores", questionScores);
    // console.log("UpdatedQuestionScores", setQuestionScores);

    const updatedExamAnswer = {
      examId: 0,
      questionBankId: currentQuestion.questionBankId,
      acutalOptionValue: correctOptions.join(","),
      enteredOptionValue: droppedWordsText.join(","),
    };

    // Reset selectedOptions for the next question
    droppedWordsText = "";

    // Check if there is already an answer for the current question
    const existingAnswerIndex = examAnswers.findIndex(
      (answer) => answer.questionBankId === currentQuestion.questionBankId
    );

    if (existingAnswerIndex !== -1) {
      // If an answer already exists, update the existing one
      setExamAnswers((prevAnswers) =>
        prevAnswers.map((answer, index) =>
          index === existingAnswerIndex ? { ...updatedExamAnswer } : answer
        )
      );
    } else {
      // If there is no existing answer, add the new answer
      setExamAnswers((prevAnswers) => [...prevAnswers, updatedExamAnswer]);
    }

    // console.log("updatedExamAnswer ", updatedExamAnswer);
    // console.log("examAnswers  ", examAnswers);
  };

  const playCorrectSound = () => {
    const correctSound = new Audio(
      require("../assets/correct-choice-43861.mp3")
    );
    correctSound.play();
    handleOpen();
  };

  const playInCorrectSound = () => {
    const incorrectSound = new Audio(
      require("../assets/wronganswer-37702.mp3")
    );
    incorrectSound.play();
    handleOpen();
  };

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  const handleContinue = () => {
    setCurrentQuestionIndex((prevIndex) =>
      Math.min(prevIndex + 1, Questions.length - 1)
    );
    setModalOpen(false);
    setDraggedWord(null);
    setDroppedWords([]);
  };

  // const handleRetry = () => {
  //   setModalOpen(false);
  //   setDraggedWord(null);
  //   if (droppedWords.length > 0) {
  //     setWordsAndImage((prevWords) => [...prevWords, ...droppedWords]);
  //   }
  //   setDroppedWords([]);
  // };
  const handleRetry = () => {
    setModalOpen(false);
    setDraggedWord(null);
    if (droppedWords.length > 0) {
      const updatedWordsAndImage = [...wordsAndImage, ...droppedWords];
      setWordsAndImage(updatedWordsAndImage);
      localStorage.setItem(
        `wordsAndImage_${currentQuestion?.questionBankId || ""}`,
        JSON.stringify(updatedWordsAndImage)
      );
    }
    setDroppedWords([]);
  };

  // const handleReset = () => {
  //   setDroppedWords([]);
  //   setDraggedWord(null);
  //   if (droppedWords.length > 0) {
  //     setWordsAndImage((prevWords: any) => [...prevWords, ...droppedWords]);
  //   }
  // };
  const clearLocalStorageForQuestion = (questionBankId: string | number) => {
    localStorage.removeItem(`wordsAndImage_${questionBankId}`);
    localStorage.removeItem(`droppedWords_${questionBankId}`);
  };

  const handleReset = () => {
    setDroppedWords([]);
    setDraggedWord(null);
    if (droppedWords.length > 0) {
      setWordsAndImage((prevWords: any) => [...prevWords, ...droppedWords]);
    }
    // Clear localStorage for the current question
    clearLocalStorageForQuestion(currentQuestion?.questionBankId || "");
    setForceUpdateWordsBox((prevValue) => prevValue + 1);
  };

  const handleNavigate = (direction: "previous" | "next") => {
    if (direction === "previous") {
      setCurrentQuestionIndex((prevIndex) => Math.max(prevIndex - 1, 0));
    } else if (direction === "next") {
      setCurrentQuestionIndex((prevIndex) =>
        Math.min(prevIndex + 1, Questions.length - 1)
      );
    }
  };

  const handlePaginationChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentQuestionIndex(value - 1);
  };

  const allowDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const touchStart = (
    event: React.TouchEvent<HTMLImageElement>,
    word: string
  ) => {
    setDraggedWord(word);
  };

  // const touchEnd = (event: React.TouchEvent<HTMLDivElement>) => {
  //   event.preventDefault();
  //   if (draggedWord) {
  //     const droppedWord = wordsAndImage.find(
  //       (word) => word.word === draggedWord
  //     );
  //     if (droppedWord) {
  //       setDroppedWords((prevWords: any) => [...prevWords, droppedWord]);
  //       setDraggedWord(null);
  //       setWordsAndImage((prevWords) =>
  //         prevWords.filter((word) => word.word !== draggedWord)
  //       );
  //     }
  //   }
  // };
  // const touchEnd = (event: React.TouchEvent<HTMLDivElement>) => {
  //   event.preventDefault();
  //   if (draggedWord) {
  //     const droppedWord = wordsAndImage.find(
  //       (word) => word.word === draggedWord
  //     );
  //     if (droppedWord) {
  //       const updatedDroppedWords = [...droppedWords, droppedWord];
  //       setDroppedWords(updatedDroppedWords);
  //       localStorage.setItem(
  //         `droppedWords_${currentQuestion?.questionBankId || ""}`,
  //         JSON.stringify(updatedDroppedWords)
  //       ); // Save to local storage for the current questionBankId
  //       setDraggedWord(null);
  //       setWordsAndImage((prevWords) =>
  //         prevWords.filter((word) => word.word !== draggedWord)
  //       );
  //     }
  //   }
  // };
  const touchEnd = (event: React.TouchEvent<HTMLDivElement>) => {
    event.preventDefault();
    if (draggedWord) {
      const droppedWord = wordsAndImage.find(
        (word: { word: string }) => word.word === draggedWord
      );
      if (droppedWord) {
        const updatedDroppedWords = [...droppedWords, droppedWord];
        setDroppedWords(updatedDroppedWords);
        localStorage.setItem(
          `droppedWords_${currentQuestion?.questionBankId || ""}`,
          JSON.stringify(updatedDroppedWords)
        );
        const updatedWordsAndImage = wordsAndImage.filter(
          (word: { word: string }) => word.word !== draggedWord
        );
        setWordsAndImage(updatedWordsAndImage);
        localStorage.setItem(
          `wordsAndImage_${currentQuestion?.questionBankId || ""}`,
          JSON.stringify(updatedWordsAndImage)
        );
        setDraggedWord(null);
      }
    }
  };

  const drag = (event: React.DragEvent<HTMLImageElement>, word: string) => {
    setDraggedWord(word);
  };

  const dragEnd = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    touchEnd(event as unknown as React.TouchEvent<HTMLDivElement>);
  };

  const [forceUpdateWordsBox, setForceUpdateWordsBox] = useState(0); // Initialize with 0

  const renderWordsBox = () => {
    return (
      <Box
        key={forceUpdateWordsBox}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
          border: "2px solid",
          borderRadius: "4px",
          width: "fit-content",
          backgroundImage: "",
          background:
            currentQuestion.answerType === 2 ? `url(${JailBars})` : "",
          backgroundSize: "cover",
          marginTop: isMobile ? "auto" : "1vh",
          marginBottom: isMobile ? "auto" : "1vh",
          padding: isMobile ? "1vh" : "auto",
        }}
      >
        {wordsAndImage.map((item: any, index: any) => (
          <Box
            key={index}
            onDragOver={allowDrop}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginLeft: isMobile ? "1.5vw" : "1vw",
              marginRight: isMobile ? "1.5vw" : "1vw",
              marginTop: isMobile ? "1.5vh" : "1vw",
              cursor: "pointer",
              flexBasis: "10%",
            }}
          >
            <img
              src={item.mediaUrl}
              alt={item.word}
              title={item.word}
              onTouchStart={(e) => touchStart(e, item.word)}
              onTouchEnd={touchEnd}
              draggable="true"
              onDragStart={(e) => drag(e, item.word)}
              onDragEnd={dragEnd}
              width={isMobile ? "35vh" : "50vh"}
              height={isMobile ? "60vh" : "70vh"}
            />
          </Box>
        ))}
      </Box>
    );
  };

  const renderTrashCan = () => {
    return (
      <Box
        id="trash-can"
        onDragOver={allowDrop}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          marginLeft: "2vw",
          marginRight: "1vw",
          cursor: "pointer",
        }}
      >
        <img
          src="https://i.imgur.com/GLksfJE.png"
          alt="Trash Can"
          //   width="100"
          width={isMobile ? "70vw" : "90vh"}
          onTouchEnd={touchEnd}
        />
      </Box>
    );
  };

  // const renderEmptyBox = () => {
  //   const droppedWord = droppedWords.length > 0 ? droppedWords[0].word : null;

  //   return (
  //     <Box
  //       id="empty-box"
  //       onDragOver={allowDrop}
  //       sx={{
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "center",
  //         flexDirection: "column",
  //         m: 1,
  //         border: "2px solid",
  //         borderRadius: "4px",
  //         cursor: "pointer",
  //         width: isMobile ? "50vw" : "30vh",
  //         height: isMobile ? "25vw" : "25vh",
  //         backgroundColor: "lightgrey",
  //         position: "relative",
  //       }}
  //     >
  //       {droppedWord ? (
  //         <img src={droppedWords[0].mediaUrl} alt={droppedWord} width="35" />
  //       ) : (
  //         <Typography
  //           variant="body1"
  //           sx={{
  //             position: "absolute",
  //             top: "50%",
  //             left: "50%",
  //             transform: "translate(-50%, -50%)",
  //           }}
  //         >
  //           Drag and drop the animal here
  //         </Typography>
  //       )}
  //     </Box>
  //   );
  // };
  const renderEmptyBox = () => {
    // Load droppedWords from local storage for the current question
    const loadedDroppedWords = loadDroppedWordsFromLocalStorage(
      currentQuestion?.questionBankId || ""
    );

    return (
      <Box
        id="empty-box"
        onDragOver={allowDrop}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          m: 1,
          border: "2px solid",
          borderRadius: "4px",
          cursor: "pointer",
          width: isMobile ? "50vw" : "30vh",
          height: isMobile ? "25vw" : "25vh",
          backgroundColor: "lightgrey",
          position: "relative",
        }}
      >
        {loadedDroppedWords.length > 0 ? (
          // Display the droppedWords from local storage
          <img
            src={loadedDroppedWords[0].mediaUrl}
            alt={loadedDroppedWords[0].word}
            width="35"
          />
        ) : (
          <Typography
            variant="body1"
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            Drag and drop the animal here
          </Typography>
        )}
      </Box>
    );
  };

  // Disable web page navigation on swipe using touchscreen(back and forward)
  useEffect(() => {
    const preventNavigation = (event: TouchEvent) => {
      event.preventDefault();
    };
    if (divRef.current) {
      divRef.current.addEventListener("touchmove", preventNavigation, {
        passive: false,
      });
    }

    return () => {
      if (divRef.current) {
        divRef.current.removeEventListener("touchmove", preventNavigation);
      }
    };
  }, []);

  const renderUIBasedOnAnswerType = () => {
    switch (currentQuestion.answerType) {
      case 1:
        return (
          <>
            {renderWordsBox()}
            {renderTrashCan()}
          </>
        );
      case 2:
        return (
          <>
            {renderWordsBox()}
            {renderEmptyBox()}
          </>
        );
    }
  };

  return (
    <div
      ref={divRef}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "auto",
        marginTop: isViewMode ? "3%" : isTablet ? "15%" : "auto",
      }}
    >
      {/* <CommonModal
        open={modalOpen}
        isCorrectSubmission={isCorrectSubmission}
        handleContinue={handleContinue}
        handleRetry={handleRetry}
        handleClose={handleClose}
      /> */}
      {showAlert && (
        <Alert
          severity="success"
          variant="filled"
          sx={{
            position: "fixed",
            top: "30%",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 9999,
            padding: "0.5",
          }}
        >
          <AlertTitle sx={{ color: "white" }}>Answer submitted</AlertTitle>
        </Alert>
      )}
      <LayoutWithIcons onNavigate={handleNavigate}>
        {currentQuestion && (
          <Card
            variant="outlined"
            sx={{
              boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
              pointerEvents: isViewMode ? "none" : "auto",
            }}
          >
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  paddingBottom: "0px",
                }}
                style={{ userSelect: "none" }}
              >
                <Typography
                  sx={{
                    fontWeight: "700",
                    fontSize: isMobile ? "100%" : "110%",
                  }}
                >
                  {questionText1}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "600",
                    fontSize: isMobile ? "100%" : "110%",
                  }}
                >
                  {questionText2}
                </Typography>
                {questionText3 !== "No text" && 
                  (
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: isMobile ? "100%" : "110%",
                      }}
                    >
                      {questionText3}
                    </Typography>
                  )
                }
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: isMobile ? "column" : "row",
                    //   mt: 2,
                  }}
                >
                  {renderUIBasedOnAnswerType()}
                </Box>
                {isViewMode && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "row",
                    }}
                  >
                    {correctOptions?.map((option, index) => (
                      <Chip
                        key={index}
                        label={option}
                        color="primary"
                        style={{ margin: "4px" }}
                        sx={{ backgroundColor: "#81c784" }}
                      />
                    ))}
                  </Box>
                )}
                {!isViewMode && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "row",
                      marginTop: "0px",
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ marginTop: "1vh", marginRight: "16px" }}
                      onClick={handleFormSubmit}
                    >
                      Submit
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      style={{ marginTop: "1vh" }}
                      onClick={handleReset}
                    >
                      Reset
                    </Button>
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>
        )}
        <Grid container lg={12} md={12} sm={12} xs={12} justifyContent="center">
          <Pagination
            count={Questions.length}
            shape="rounded"
            sx={{
              marginBottom: "1vh",
              paddingTop: "4%",
            }}
            page={currentQuestionIndex + 1}
            onChange={handlePaginationChange}
          />
        </Grid>
      </LayoutWithIcons>
    </div>
  );
};

export default Layout13;
